import React from 'react';
import { Icon } from '@app/src/common/Icon';
import { Modal } from '@app/src/common/Modal';
import {
  Wrapper,
  Title,
  Detail,
  Actions,
  ButtonCancel,
  ButtonDelete,
  LoaderWrapper
} from './styled';

interface Props {
  handleCloseModal?: Function;
  handleClickCancel?: Function;
  handleClickConfirm?: Function;
  isDisplay?: boolean;
  isLoadingButtonConfirm?: boolean;
  isDisabledButtonConfirm?: boolean;
  state?: number;
}

const AD_INACTIVE = 2;

export const ModalConfirm: React.FC<Props> = ({
  handleCloseModal,
  isDisplay,
  handleClickCancel,
  handleClickConfirm,
  isLoadingButtonConfirm,
  isDisabledButtonConfirm,
  state
}) => (
  <Modal show={isDisplay} closeModal={handleCloseModal} customBody>
    <Wrapper>
      {
        state === AD_INACTIVE ?
          <Title>¿Desea eliminar los avisos seleccionados?</Title>
          :
          <Title>¿Desea finalizar los avisos seleccionados?</Title>
      }
      {
        state === AD_INACTIVE ?

          <Detail>
            Esta acción solo eliminará este historial.<br />
            Si seleccionaste un aviso impreso, no afectará su publicación.
          </Detail>
          :
          <Detail>
            Si seleccionaste un aviso impreso, esta acción no afectará su publicación.
          </Detail>
      }
      <Actions>
        <ButtonCancel onClick={handleClickCancel} isDisabled={isDisabledButtonConfirm}>Cancelar</ButtonCancel>
        <ButtonDelete onClick={handleClickConfirm}>
          {
            isLoadingButtonConfirm ?
              <LoaderWrapper><Icon data-name='icon-circle' fill='#ccc' width={'16'} height={'16'} /></LoaderWrapper>
              :
              <React.Fragment>{state === AD_INACTIVE ? 'Eliminar' : 'Finalizar'}</React.Fragment>
          }
        </ButtonDelete>
      </Actions>
    </Wrapper>
  </Modal>
)